import React, { useRef, useEffect } from "react";

import {
  AlignmentType,
  Document,
  HeadingLevel,
  Packer,
  Paragraph,
  TabStopPosition,
  TabStopType,
  TextRun,
  Table,
  TableRow,
  TableCell,
  PageOrientation,
  Alignment,
  Header,
  VerticalAlign,
  HorizontalPosition,
  ShadingType,
  PageBreak,
  PageNumber,
  Footer,
} from "docx";

import { saveAs } from "file-saver";

// Scss imports
import css from "./ReactDocxArchive.module.scss";
import { RiLandscapeLine } from "react-icons/ri";

// redux imports
import { useSelector, useDispatch } from "react-redux";
import { getCurrentUserData } from "../../redux/actions/currentUserActions";
interface ReactDocxProps {
  archivedDocumentsForPrinting: any;
  disabled: boolean;
  papersYear: any;
}

const ReactDocx: React.FC<ReactDocxProps> = ({
  archivedDocumentsForPrinting,
  disabled,
  papersYear,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCurrentUserData);
  }, []);

  // current user data
  const currentUserData = useSelector(
    (state: any) => state.currentUser.currentUserData
  );

  const archiveForWord = useSelector(
    (state: any) => state.archive.arhiveForWord
  );

  const tableHeader = [
    new TableRow({
      cantSplit: false,
      tableHeader: true,

      children: [
        new TableCell({
          children: [
            new Paragraph({
              text: "Ред. бр.",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
        new TableCell({
          children: [
            new Paragraph({
              text: "Датум",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
        new TableCell({
          children: [
            new Paragraph({
              text: "Година раздобља/настанка",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
        new TableCell({
          children: [
            new Paragraph({
              text: "Редни број из листе",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
        new TableCell({
          children: [
            new Paragraph({
              text: "Подбројеви",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
        new TableCell({
          children: [
            new Paragraph({ text: "Садржај", alignment: AlignmentType.CENTER }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
        new TableCell({
          children: [
            new Paragraph({
              text: "Количина",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
        new TableCell({
          children: [
            new Paragraph({
              text: "Датум записника",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
        new TableCell({
          children: [
            new Paragraph({
              text: "Број записника",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
        new TableCell({
          children: [
            new Paragraph({
              text: "Рок чувања",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
        new TableCell({
          children: [
            new Paragraph({
              text: "Напомена",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            fill: "#DCDCDC",
          },
        }),
      ],
    }),
  ];

  const tableBody = archiveForWord
    ? archiveForWord.map((archiveItem, index) => {
        const date: any = new Date(archiveItem.createdAt.split("T")[0]);
        const papersFrom: string = new Date(
          archiveItem.papersFrom.split("T")[0]
        ).toLocaleDateString("sr-RS", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });

        const papersTo: string = new Date(
          archiveItem.papersTo.split("T")[0]
        ).toLocaleDateString("sr-RS", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });

        return new TableRow({
          cantSplit: false,
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: (index + 1).toString(),
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: new Date(
                    archiveItem.createdAt.split("T")[0]
                  ).toLocaleDateString("sr-RS", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  }),
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: `${papersFrom} - ${papersTo}`,
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: archiveItem.baseNumber.baseNumber
                    ? archiveItem.baseNumber.baseNumber.toString()
                    : "",
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),

            new TableCell({
              children: [
                new Paragraph({
                  text: archiveItem.subnumbers
                    ? archiveItem.subnumbers.reduce(
                        (prev, curr) => prev + ", " + curr
                      )
                    : "",
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: archiveItem.content,
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: archiveItem.numberOfPapers
                    ? archiveItem.numberOfPapers.toString()
                    : "",
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text:
                    archiveItem.recordDate && archiveItem.recordNumber !== "N/A"
                      ? new Date(
                          archiveItem.recordDate.split("T")[0]
                        ).toLocaleDateString("sr-RS", {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        })
                      : "",
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text:
                    archiveItem.recordNumber &&
                    archiveItem.recordNumber !== "N/A"
                      ? archiveItem.recordNumber
                      : "",
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: archiveItem.shelfLifeTo
                    ? archiveItem.shelfLifeTo.toString()
                    : "",
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: archiveItem.remark,
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
          ],
        });
      })
    : "";
  //data.push(allPagePapers);

  const table = new Table({
    margins: {
      top: 50,
      bottom: 50,
      left: 50,
      right: 50,
    },

    rows: [...tableHeader, ...tableBody],
  });

  const createHeader = (headerTitle) => {
    return new Paragraph({
      alignment: AlignmentType.CENTER,
      heading: HeadingLevel.HEADING_1,
      children: [
        new TextRun({
          text: `${headerTitle}`,
          style: "Heading1",
        }),
      ],
    });
  };

  const createContactInfo = (companyName, address, mb) => {
    return new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: {
        after: 150,
      },
      children: [
        new TextRun({
          text: `${companyName.length > 0 ? companyName : ""}`,
          style: "wellSpaced",
          break: 1,
          bold: true,
        }),
        new TextRun({
          text: `Адреса: ${address ? address : ""}`,
          style: "wellSpaced",
          break: 1,
        }),
        /*new TextRun({
          text: `${"Матични број: " + mb}`,
          style: "wellSpaced",
          break: 1,
        }),*/
      ],
    });
  };

  const renderAddress = () => {
    let place = "";
    let municipality = "";
    let street = "";
    let apartmentNumber = "";
    if (currentUserData.place && currentUserData.place.length > 0) {
      place = currentUserData.place;
    }
    if (
      currentUserData.municipality &&
      currentUserData.municipality.length > 0
    ) {
      municipality = currentUserData.municipality;
    }
    if (currentUserData.street && currentUserData.street.length > 0) {
      street = currentUserData.street;
    }
    if (
      currentUserData.apartmentNumber &&
      currentUserData.apartmentNumber.length > 0
    ) {
      apartmentNumber = currentUserData.apartmentNumber;
    }

    return place + ", " + municipality + ", " + street + ", " + apartmentNumber;
  };

  const renderMb = () => {
    let nationalId = "";
    let identificationNumber = "";

    if (currentUserData.nationalId && currentUserData.nationalId.length > 0) {
      nationalId = currentUserData.nationalId;
    }
    if (
      currentUserData.identificationNumber &&
      currentUserData.identificationNumber.length > 0
    ) {
      nationalId = currentUserData.identificationNumber;
    }
    return nationalId + ", " + identificationNumber;
  };

  async function exportToWord() {
    const doc = new Document({
      styles: {
        paragraphStyles: [
          {
            id: "Heading1",
            name: "Heading 1",

            quickFormat: true,
            run: {
              size: 40,
              bold: true,
              font: "TimesNewRoman",
              color: "black",
            },
            paragraph: {
              spacing: {
                after: 120,
              },
            },
          },
          {
            id: "wellSpaced",
            name: "Well Spaced",
            basedOn: "Normal",
            quickFormat: true,
            run: {
              size: 12,
              font: "TimesNewRoman",
              color: "black",
            },
            paragraph: {
              spacing: {
                line: 276,
                before: 20 * 72 * 0.1,
                after: 20 * 72 * 0.05,
              },
            },
          },
          {
            id: "paragraphBold",
            name: "paragraphBold",
            basedOn: "Normal",
            quickFormat: true,
            run: {
              size: 12,
              bold: true,
              font: "TimesNewRoman",
              color: "black",
            },
            paragraph: {
              spacing: {
                line: 276,
                before: 20 * 72 * 0.1,
                after: 20 * 72 * 0.05,
              },
            },
          },
        ],
      },

      sections: [
        {
          properties: {
            page: {
              pageNumbers: {
                start: 1,
              },
              size: {
                orientation: PageOrientation.LANDSCAPE,
              },
            },
          },
          /*headers: {
            default: new Header({
              children: [
                new Paragraph({
                  children: [
                    new TextRun("Foo Bar corp. "),
                    new TextRun({
                      children: ["Page Number ", PageNumber.CURRENT]
                    }),
                    new TextRun({
                      children: [" to ", PageNumber.TOTAL_PAGES]
                    })
                  ]
                })
              ]
            })
          },*/
          footers: {
            default: new Footer({
              children: [
                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  children: [
                    new TextRun({
                      children: ["Број стана: ", PageNumber.CURRENT],
                    }),
                    new TextRun({
                      children: [" од ", PageNumber.TOTAL_PAGES],
                    }),
                  ],
                }),
              ],
            }),
          },
          children: [
            createHeader("Архивска књига"),
            createContactInfo(
              currentUserData.lastName
                ? "Име и презиме: " +
                    currentUserData.firstName +
                    " " +
                    currentUserData.lastName
                : "Име фирме: " + currentUserData.businessName,
              renderAddress(),
              renderMb()
            ),
            table,
          ],
        },
      ],
    });

    const buffer = await Packer.toBuffer(doc);

    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    //const link = document.createElement("a");
    //saveAs(blob, `arhiva-za-${papersYear}-godinu`);
    //saveAs(blob, `arhivska-knjiga`);
    //link.href = window.URL.createObjectURL(blob);
    //link.download = "my.docx";
    //link.click();
  }
  return (
    <div
      onClick={() => {
        exportToWord();
      }}
      className={css.buttonWrapper}
    >
      <button>Иштампај</button>
    </div>
  );
};

export default ReactDocx;
